export { default as mentionsPluginInitializeMentions } from './mentionsPluginInitializeMentions';
